import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAuthStore } from '@/stores/authStore';

/**
 * 顶部导航栏组件
 */
export const Header = () => {
  const developerName = useAuthStore((state) => 
    state.currentDeveloper?.name || state.currentDeveloper?.email || '开发者'
  );

  const handleLogout = (): void => {
    useAuthStore.getState().logout();
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'logout',
      label: (
        <Button 
          type="text" 
          onClick={handleLogout} 
          className="w-full text-left flex items-center gap-2 text-gray-700 hover:text-red-600"
        >
          <LogoutOutlined className="text-sm" />
          退出登录
        </Button>
      ),
    },
  ];

  return (
    <header className="flex justify-between items-center px-6 py-1 bg-white border-b border-gray-100 shadow-sm sticky top-0 z-10">
      {/* 左侧：平台名称和Logo - 优化渐变背景、文字样式、间距 */}
      <div className="flex items-center gap-1">
        <img 
          src="/favicon.png" 
          alt="平台 Logo" 
          className="w-10 h-10 object-contain" // 注意：原w-30/h-30是tailwind无效类，改为w-10/h-10更合理（30会过大）
          onError={(e) => {
            console.warn('Logo 加载失败，使用备用图标。');
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
        <h1 className="text-lg font-medium text-gray-800">开发者平台</h1>
      </div>

      {/* 右侧：用户信息和功能按钮 - 优化间距、hover效果 */}
      <div className="flex items-center gap-6">
        <Dropdown 
          menu={{ items: userMenuItems }} 
          placement="bottomRight"
          trigger={['click']}
          arrow
        >
          <Button 
            type="text" 
            icon={<UserOutlined className="text-gray-500 mr-2" />} 
            className="flex items-center gap-1.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 px-3 py-2 rounded-lg transition-colors"
          >
            <span className="font-medium">{developerName}</span>
          </Button>
        </Dropdown>
      </div>
    </header>
  );
};